// extracted by mini-css-extract-plugin
export var codeColumn = "Input-module--codeColumn--mB3iy";
export var column = "Input-module--column--l8GDj";
export var details = "Input-module--details--ogzuL";
export var leftText = "Input-module--leftText---9s4E";
export var root = "Input-module--root--grxPu";